export default {
    // récuperer toutes les agences dans la base de données 
    get_histories_by_model(data){
        return axios.get('/audit/'+data.name_model+'/' + data.id_model, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_histories_by_agency(id_agency){
        return axios.get('/audit/agence/' + id_agency,{
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_histories_by_atm(id_guichet){
        return axios.get('/audit/guichet/' + id_guichet,{
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les agences dans la base de données 
    post_agency(agence){
        return axios.post('/agences',agence, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    put_agency(id,agence){
        return axios.put('/agences/'+id,agence, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    show_agency(id){
        return axios.get('/agences/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    delete_agences(id){
        return axios.delete('/agences/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

}